import { render, staticRenderFns } from "./AlertIcons.vue?vue&type=template&id=3c3e7566&scoped=true&"
import script from "./AlertIcons.vue?vue&type=script&lang=js&"
export * from "./AlertIcons.vue?vue&type=script&lang=js&"
import style0 from "./AlertIcons.vue?vue&type=style&index=0&id=3c3e7566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e7566",
  null
  
)

export default component.exports